import React from 'react';
import { Button } from 'reactstrap';
import { useFieldArray } from 'react-hook-form';

export default function({ form, arrayName, formname }) {
  const { control, register } = form;
  const array = `${formname}.${arrayName}`;
  const locations = useFieldArray({ control, name: `${array}` });

  return (
    <div>
      {locations.fields.map((item, index) => (
        <div key={item.id}>
          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">
              Location Type {index + 1}
              <small className="ml-1">(e.g Bld, Apt)</small>
            </span>
            <input
              className="form-control"
              defaultValue={item.Type}
              {...register(`${array}.${index}.Type`)}
            />
          </label>
          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">
              Location Value {index + 1}
              <small className="ml-1">(e.g 1, 2B)</small>
            </span>
            <input
              className="form-control"
              defaultValue={item.Value}
              {...register(`${array}.${index}.Value`)}
            />
          </label>

          <Button type="button" onClick={() => locations.remove(index)}>
            Delete
          </Button>

          {index + 1 === locations.fields.length && (
            <div className="d-inline-block align-self-end ml-2">
              <Button
                onClick={() => locations.append({ Type: '', Value: '' })}
                type="button"
                className="mr-2 align-self-bottom"
              >
                Add Location
              </Button>
            </div>
          )}
        </div>
      ))}

      {locations.fields.length === 0 && (
        <div className="d-inline-block align-self-end p-3">
          <Button
            onClick={() => locations.append({ Type: '', Value: '' })}
            type="button"
            className="mr-2 align-self-bottom"
          >
            Add Location
          </Button>
        </div>
      )}
    </div>
  );
}
